//!#system	

<template>
	<div>
		<fieldset class="field-fs">
			<legend><strong style="font-size: 150%;" class="primary--text">{{value.name}}</strong> ({{value.type}})</legend>
			<v-btn 
				class="float-right" 
				@click="remove(value)"
				fab
				dark 
				small
			>
				<v-icon dark small>mdi-trash-can-outline</v-icon>
			</v-btn>
			<v-switch
				inset
				v-model="value.enabled"
				label="Enabled"
			/>
			<v-combobox
				v-model="value.default"
				label="Initial value"
				:items="['Empty/null']"
			/>
			<v-switch
				inset
				v-model="value.index"
				label="Indexed"
			/>
			<v-switch
				inset
				v-model="value.listScreen"
				label="List screens & APIs"
			/>
			<v-combobox
				v-model="value.valueList"
				label="Value list (optional)"
				:items="value.valueList"
				multiple
				chips
				hint="Hit enter to add an option"
				persistent-hint
			/>
		</fieldset>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Object,
			default: () => { return {} }
		}
	},
	methods: {
		remove(field) {
			if (field.committed) {
				this.$store.dispatch('app/applyObjectError', {
					show: true,
					text: 'You cannot delete a field that has been saved - you can mark it as not enabled though.'
				});
				return;
			}
			this.$emit('remove', field);
		}
	}
}
</script>

<style scoped>
.field-fs {
	padding: 20px;
	border: 3px solid #eee;
	position: relative;
	margin-bottom: 20px;
}
.field-fs legend {
	padding: 0 20px 0 20px;
}
</style>